import React, {useEffect, useRef, useState} from 'react';
import {styles} from './Utilities/ProactiveMetricsDetailStyles';
import {Box} from "@mui/material";
import {queryStringToObject, objectToQueryString, currentUser} from "_helpers";
import {CampaignMetricsDetailComponent} from "./ProactiveMetricsDetailComponent";
import {acquireActions, proactiveActions, retainActions} from "_actions";
import {useDispatch, useSelector} from "react-redux";
import _, { initial, orderBy, sortBy } from "lodash";
import moment from "moment";
import useLocationQueryParams from "../../hooks/useLocationQueryParams";
import {ACQUIRE_CAMPAIGNS, RETAIN_CAMPAIGNS} from "../RetainDashboard/Utilities/CampaignUtils";
import { userRoles } from '_constants';

const defaultFormat = 'YYYY-MM-DD HH:mm:ss'
const startDateDefault = moment().subtract(2, 'years');
const endDateDefault = moment().add(1, 'd').format(defaultFormat);

export const ProactiveMetricsDetailContainer = ({ location, history }) => {
    const search = location.search.substring(1);
    const filterParams = queryStringToObject(search);
    const { setParams } = useLocationQueryParams();
    let { campaignIds: campaignId, pageFilter, organizationId, source } = filterParams;
    let initialStartDate = filterParams.startDate || startDateDefault;
    let initialEndDate = filterParams.endDate || endDateDefault;
    let offset = parseInt(filterParams.offset, 10) || 0;
    let currentPage = parseInt(filterParams.currentPage, 10) || 0;

    const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
    const [isCampaignNameDropdownOpen, setIsCampaignNameDropdownOpen] = useState(false);
    const [selectedCriteria, setSelectedCriteria] = useState('all_messages');
    const [pageParams, setPageParams] = useState({offset, currentPage});
    const [dateRange, setDateRange] = useState({startDate: initialStartDate, endDate: initialEndDate});
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [liked, setLiked] = useState(Boolean(filterParams.liked));
    const [replied, setReplied] = useState(Boolean(filterParams.replied));
    const [noEngagement, setNoEngagement] = useState(Boolean(filterParams.noEngagement));
    const [followed, setFollowed] = useState(Boolean(filterParams.followed));
    const [converted, setConverted] = useState(Boolean(filterParams.converted));
    const [followUpSent, setFollowUpSent] = useState(Boolean(filterParams.followUpSent));
    const [convertedAfterFollowUpSent, setConvertedAfterFollowUpSent] = useState(Boolean(filterParams.convertedAfterFollowUpSent));
    const [hasAdditionalOrders, setHasAdditionalOrders] = useState(Boolean(filterParams.hasAdditionalOrders));
    const [orderedWithin5Days, setOrderedWithin5Days] = useState(Boolean(filterParams.orderedWithin5Days));
    const [orderedRecommendedCategory, setOrderedRecommendedCategory] = useState(Boolean(filterParams.orderedRecommendedCategory));
    const [orderedRecommendedProduct, setOrderedRecommendedProduct] = useState(Boolean(filterParams.orderedRecommendedProduct));
    const [usedDiscount, setUsedDiscount] = useState(Boolean(filterParams.usedDiscount));
    const [usedExactDiscountCode, setUsedExactDiscountCode] = useState(Boolean(filterParams.usedExactDiscountCode));
    const [lastTouch, setLastTouch] = useState(Boolean(filterParams.lastTouch));

    const [sortBy, setSortBy] = useState(filterParams.sortBy || 'date');
    const [orderBy, setOrderBy] = useState(filterParams.orderBy || 'desc');
    const filterRef = useRef(null);
    const filterPageRef = useRef(null);
    const maxItemsPerPage = 10;

    const dispatch = useDispatch()
    const { startDate, endDate } = dateRange;
    const proactive = useSelector(state => state.proactive);
    const retainCampaigns = useSelector(state => state.retain);
    const acquireCampaigns = useSelector(state => state.acquire);
    const campaignsObj = proactive.organizationCampaigns;
    const retainCampaignsObj =  retainCampaigns.retainCampaigns;
    const acquireCampaignsObj =  acquireCampaigns.acquireCampaigns;
    const allCampaignList = _.get(campaignsObj, 'items') || [];
    const retainCampaignList = _.get(retainCampaignsObj, 'items') || [];
    const acquireCampaignList = _.get(acquireCampaignsObj, 'items') || [];
    const extractAllCampaignsList = allCampaignList.map(({ name, id }) => ({ name, id }));
    const extractRetainCampaignList = retainCampaignList.map(({ campaign }) => ({ name: campaign.name, id: campaign.id }));
    const extractAcquireCampaignList = acquireCampaignList.map(({ campaign }) => ({ name: campaign.name, id: campaign.id }));

    const getExtractedCampaignList = () => {
        switch (pageFilter) {
            case RETAIN_CAMPAIGNS:
                return extractRetainCampaignList
            case ACQUIRE_CAMPAIGNS:
                return extractAcquireCampaignList
            default:
                return extractAllCampaignsList;
        }
    };


    let payload = {
        source: source,
        organizationId: organizationId,
        campaignIds: campaignId,
        startDate: moment(startDate).startOf('day').toISOString(),
        endDate: moment(endDate).endOf('day').toISOString(),
        replied: replied,
        liked: liked,
        noEngagement: noEngagement,
        currentPage: pageParams.currentPage,
        offset: pageParams.offset,
        limit: maxItemsPerPage,
        followed: followed,
        converted: converted,
        followUpSent: followUpSent,
        convertedAfterFollowUpSent: convertedAfterFollowUpSent,
        hasAdditionalOrders: hasAdditionalOrders,
        orderedWithin5Days: orderedWithin5Days,
        orderedRecommendedCategory: orderedRecommendedCategory,
        orderedRecommendedProduct: orderedRecommendedProduct,
        usedDiscount: usedDiscount,
        usedExactDiscountCode: usedExactDiscountCode,
        lastTouch: lastTouch,
        pageFilter,
        sortBy,
        orderBy
    }

    let formattedPayload = (payload) => {
    //Only send values for 1. Replied - ?replied=true 2.Liked - ?liked=true 3.No Engagement - ?replied=false&liked=false
        const basePayload = {
            source: payload.source,
            organizationId: payload.organizationId,
            campaignIds: payload.campaignIds,
            startDate: payload.startDate,
            endDate: payload.endDate,
            currentPage: payload.currentPage,
            offset: payload.offset,
            limit: payload.limit,
            pageFilter: payload.pageFilter,
            sortBy: payload.sortBy,
            orderBy: payload.orderBy
        };

        if (payload.liked) {
            return { ...basePayload, liked: payload.liked };
        } else if (payload.replied) {
            return { ...basePayload, replied: payload.replied };
        } else if (payload.noEngagement) {
            return { ...basePayload, noEngagement: payload.noEngagement };
        } else if (payload.followed) {
            return {...basePayload, followed: payload.followed };
        } else if (payload.converted) {
            return {...basePayload, converted: payload.converted };
        } else if (payload.followUpSent) {
            return {...basePayload, followUpSent: payload.followUpSent };
        } else if (payload.convertedAfterFollowUpSent) {
            return {...basePayload, convertedAfterFollowUpSent: payload.convertedAfterFollowUpSent };
        } else if (payload.hasAdditionalOrders) {
            return {...basePayload, hasAdditionalOrders: payload.hasAdditionalOrders };
        } else if (payload.orderedWithin5Days) {
            return {...basePayload, orderedWithin5Days: payload.orderedWithin5Days };
        } else if (payload.orderedRecommendedCategory) {
            return {...basePayload, orderedRecommendedCategory: payload.orderedRecommendedCategory };
        } else if (payload.orderedRecommendedProduct) {
            return {...basePayload, orderedRecommendedProduct: payload.orderedRecommendedProduct };
        } else if (payload.usedDiscount) {
            return {...basePayload, usedDiscount: payload.usedDiscount };
        } else if (payload.usedExactDiscountCode) {
            return {...basePayload, usedExactDiscountCode: payload.usedExactDiscountCode };
        } else if (payload.lastTouch) {
            return {...basePayload, lastTouch: payload.lastTouch };
        }
        return basePayload;
    }
    const filteredPayload = formattedPayload(payload)

    const handleFiltersSubmit = (params) => {
        const isEvent =
            params &&
            (typeof params.preventDefault === 'function' ||
                params.nativeEvent ||
                params.target ||
                params.type === 'click');

        const updatedPayload = isEvent
            ? filteredPayload
            : { ...filteredPayload, ...params };

        setParams(updatedPayload);
        dispatch(proactiveActions.getProactiveMessagesList(updatedPayload, source));
        setIsFilterDropdownOpen(false);
        dispatch(proactiveActions.clearConversation());
    };

    const handleFilterReset = () => {
        setSelectedCriteria("all_messages")
    }

    const onSelectChangeHandler = (currentSelectedOption) => {
        const initialPayload = { ...filteredPayload, campaignIds: currentSelectedOption.id, pageFilter:pageFilter, offset: 0, currentPage: 0 };
        const queryString = objectToQueryString(initialPayload);

        history.push({
            pathname: location.pathname,
            search: `?${queryString}`
        });
        dispatch(proactiveActions.clearConversation())
    };

    const closeOpenFilterDropdown = (e)=>{
        if(filterRef.current && isFilterDropdownOpen && !filterRef.current.contains(e.target)){
            setIsFilterDropdownOpen(false)
        }
        if(filterPageRef.current && isCampaignNameDropdownOpen && !filterPageRef.current.contains(e.target)){
            setIsCampaignNameDropdownOpen(false)
        }
    }
    document.addEventListener('mousedown',closeOpenFilterDropdown)

    const handleExport = () => {
        dispatch(proactiveActions.exportProactiveMessages(filteredPayload))
    }

    const handleExportMobius = () => {
        dispatch(proactiveActions.exportProactiveMessagesMobius(filteredPayload))
    }

    useEffect(() => {
        if (!isFirstLoad) {
            const queryString = objectToQueryString(filteredPayload);
            history.push({
                pathname: location.pathname,
                search: `?${queryString}`
            });
            return
        }

        const currentUserRole = currentUser && currentUser.roles && currentUser.roles[ 0 ];
        const isChatdeskAdmin = currentUser && currentUserRole === userRoles.CHATDESK_ADMIN_ROLE; 

        if(pageFilter === RETAIN_CAMPAIGNS && retainCampaignList.length === 0){
            if (isChatdeskAdmin && organizationId) {
                dispatch(retainActions.getOrganizationRetainCampaigns(organizationId));
            } else {
                dispatch(retainActions.getCompanyRetainCampaigns());
            }
        }else if(pageFilter === ACQUIRE_CAMPAIGNS && acquireCampaignList.length === 0){
            if (isChatdeskAdmin && organizationId) {
                dispatch(acquireActions.getOrganizationAcquireCampaigns(organizationId));
            } else {
                dispatch(acquireActions.getCompanyAcquireCampaigns());
            }
        }else{
            if (allCampaignList.length === 0) {
                dispatch(proactiveActions.getCompanyCampaigns({
                    organizationId,
                    offset,
                    limit: 1000
                }, '', true));
            }
        }

        setIsFirstLoad(false);
    }, [startDate, endDate, pageParams])

    useEffect(() => {
        handleFiltersSubmit()
    }, []);

    return (
        <Box sx={styles.root}>
            <Box sx={styles.container}>
                <CampaignMetricsDetailComponent
                    source={source}
                    organizationId={organizationId}
                    pageFilter={pageFilter}
                    isFilterDropdownOpen={isFilterDropdownOpen}
                    setIsFilterDropdownOpen={setIsFilterDropdownOpen}
                    isCampaignNameDropdownOpen={isCampaignNameDropdownOpen}
                    setIsCampaignNameDropdownOpen={setIsCampaignNameDropdownOpen}
                    selectedCriteria={selectedCriteria}
                    setSelectedCriteria={setSelectedCriteria}
                    filterRef={filterRef}
                    filterPageRef={filterPageRef}
                    handleExport={source === "MOBIUS" ? handleExportMobius : handleExport }
                    pageParams={pageParams}
                    setPageParams={setPageParams}
                    selectedDropdownOption={getExtractedCampaignList().find(campaign => campaign.id === campaignId)}
                    onSelectChangeHandler={onSelectChangeHandler}
                    onFilterFormSubmit={handleFiltersSubmit}
                    dateRange={dateRange}
                    setDateRange={setDateRange}
                    handleFilterReset={handleFilterReset}
                    extractedCampaignList={getExtractedCampaignList()}
                    setLiked={setLiked}
                    setReplied={setReplied}
                    setNoEngagement={setNoEngagement}
                    setFollowed={setFollowed}
                    setConverted={setConverted}
                    setFollowUpSent={setFollowUpSent}
                    setConvertedAfterFollowUpSent={setConvertedAfterFollowUpSent}
                    setHasAdditionalOrders={setHasAdditionalOrders}
                    setOrderedWithin5Days={setOrderedWithin5Days}
                    setOrderedRecommendedCategory={setOrderedRecommendedCategory}
                    setOrderedRecommendedProduct={setOrderedRecommendedProduct}
                    setUsedDiscount={setUsedDiscount}
                    setUsedExactDiscountCode={setUsedExactDiscountCode}
                    setLastTouch={setLastTouch}
                    sortBy={sortBy}
                    setSortBy={setSortBy}
                    orderBy={orderBy}
                    setOrderBy={setOrderBy}
                />
            </Box>
        </Box>
    )
}